import { v4 as uuidv4 } from 'uuid';

import {
  ReadFilterByIdApiResponse,
  SurveyAndOutgoingChannelLink,
} from '../types';

/**
 * Returns the transformed filter with ids for each contact point.
 *
 * @param response The original response from the ratings endpoint.
 */
export function transformReadFilterByIdApiResponse(
  response: any,
): ReadFilterByIdApiResponse {
  const {
    data: { survey_and_outgoing_channel_links: contactPriorities },
  } = response;

  response.data.survey_and_outgoing_channel_links = contactPriorities.map(
    (link: SurveyAndOutgoingChannelLink) => ({
      ...link,
      id: uuidv4(),
    }),
  );

  return response;
}
